import { withSvgIcon } from './withSvgIcon';

export const NotificationBellIcon = withSvgIcon(
  <>
    <path d="M8 17.5H12"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M4 8.5C4 5.18629 6.68629 2.5 10 2.5V2.5C13.3137 2.5 16 5.18629 16 8.5V14.5H4V8.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />

  </>,
  { viewBox: '0 0 20 20' },
);
